<template>
  <div>
    <p class="titleModal">
      {{ $t(`technicalFile.boiler.step0.title`) }}
    </p>
    <v-row>
      <v-col
        cols="12"
        class="noYPadding"
      >
        <div>
          <VDatePicker
            v-model="data.evaluationDate"
            outlined
            :disabled="readonly"
            flat
            data-cy="network-identification-date"
            :label="$t('technicalFile.cooling.step0.auditDate')"
            @input="updateData"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import VDatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker';

export default {
    name: 'EvaluationDate',
    components: {
        VDatePicker,
    },
    props: {
        evaluationDate: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
        };
    },
    watch: {
        evaluationDate: {
            handler() {
                this.data = { ...this.data, ...this.evaluationDate };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { evaluationDate: this.data });
        },
    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
  padding-bottom: 0;
  padding-top: 0;
}
</style>
